import type { Reducer } from 'redux';

import {
    APPLY_LEASE_CONTRACT_FIELDS,
    APPLY_LEASE_CONTRACT_FIELDS_FAILURE,
    APPLY_LEASE_CONTRACT_FIELDS_SUCCESS,
    REQUEST_LEASE_CONTRACT_FIELDS
} from '../actionTypes/leaseContractingFieldsActionTypes';

interface LeaseContractingFields {
    retroMiles?: number;
    initialMilesCharged?: number;
    thresholdMiles?: number;
    initialMileageCharged?: number;
    totalExcessMilesPurchased?: number;
    mileagePenaltyRate?: number;
    totalMiles?: number;
    excessMileRate?: number;
    standardAllowedMiles?: number;
    inceptionRate?: number;
    milesAtInception?: number;
}

export type LeaseContractingFieldsState = {
    fields: LeaseContractingFields;
    isCalculating: boolean;
    errorMessages: string[] | null;
};

export type LeaseContractingFieldsActions =
    | { type: typeof REQUEST_LEASE_CONTRACT_FIELDS; payload: Record<string, any> }
    | { type: typeof APPLY_LEASE_CONTRACT_FIELDS; payload: Record<string, any> }
    | { type: typeof APPLY_LEASE_CONTRACT_FIELDS_SUCCESS; payload: Record<string, any> }
    | { type: typeof APPLY_LEASE_CONTRACT_FIELDS_FAILURE; payload: string[] | null };

export const initialLeaseContractingFieldsState: LeaseContractingFieldsState = {
    fields: {},
    isCalculating: false,
    errorMessages: null
};

export type LeaseContractingFieldsReducer = Reducer<LeaseContractingFieldsState, LeaseContractingFieldsActions>;

export const reducer: LeaseContractingFieldsReducer = (state = initialLeaseContractingFieldsState, action) => {
    switch (action.type) {
        case REQUEST_LEASE_CONTRACT_FIELDS:
            return {
                ...state,
                isCalculating: false,
                fields: action.payload,
                errorMessages: null
            };

        case APPLY_LEASE_CONTRACT_FIELDS:
            return {
                ...state,
                isCalculating: true,
                fields: action.payload,
                errorMessages: null
            };

        case APPLY_LEASE_CONTRACT_FIELDS_SUCCESS:
            return {
                ...state,
                isCalculating: false,
                fields: action.payload,
                errorMessages: null
            };
        case APPLY_LEASE_CONTRACT_FIELDS_FAILURE:
            return {
                ...state,
                isCalculating: false,
                errorMessages: action.payload
            };

        default:
            return state;
    }
};
